import type { FC } from "react";
import styles from "./FormSkeleton.module.scss";

interface SkeletonFieldProps {
    labelWidth?: number;
    inputHeight?: number;
    fullWidth?: boolean;
}

const SkeletonField: FC<SkeletonFieldProps> = ({ labelWidth = 120, inputHeight = 30, fullWidth = false }) => (
    <div className={`${styles.field} ${fullWidth ? styles.fullWidth : ""}`}>
        <div className={styles.label} style={{ maxWidth: labelWidth }} />
        <div className={styles.input} style={{ height: inputHeight }} />
    </div>
);

const SkeletonButton: FC<{ width?: number }> = ({ width = 96 }) => <div className={styles.button} style={{ width }} />;

const SkeletonLink: FC<{ width?: number }> = ({ width = 145 }) => <div className={styles.link} style={{ width }} />;

/**
 * A skeleton placeholder for form loading states.
 * Matches the structure and dimensions of the ClassicForm.
 */
export const FormSkeleton: FC = () => (
    <div className={styles.formSkeleton}>
        {/* Name row: First & Middle Name + Last Name */}
        <div className={styles.nameRow}>
            <SkeletonField labelWidth={160} />
            <SkeletonField labelWidth={80} />
        </div>

        {/* Delimiter */}
        <div className={styles.delimiter} />

        {/* Place + Birth Year row */}
        <div className={styles.placeRow}>
            <SkeletonField labelWidth={240} />
            <SkeletonField labelWidth={70} />
        </div>

        {/* Action row: Search + Show options + Match exactly */}
        <div className={styles.actionRow}>
            <SkeletonButton width={96} />
            <SkeletonLink width={145} />
        </div>
    </div>
);
